/* Links work without JavaScript. Focus and hover provide optional previews. */
(function () {
    var places = {
        sabah: ["Borneo", "Sabah", "Explore the history of North Borneo, its communities and the development of present-day Sabah."],
        sarawak: ["Borneo", "Sarawak", "Indigenous communities, river trade and the Brooke period form part of Sarawak's historical record."],
        brunei: ["Borneo", "Brunei", "Explore the history of the Brunei Sultanate and its regional maritime relationships."],
        kalimantan: ["Borneo", "Kalimantan", "The Indonesian region of Borneo, with histories shaped by river communities, trade and regional kingdoms."],
        singapore: ["Southeast Asia", "Singapore", "From the trading settlement of Temasek to the development of a modern city-state."],
        "peninsular-malaysia": ["Southeast Asia", "Peninsular Malaysia", "The Malay Peninsula, its historical states, trading ports and cultural heritage."],
        thailand: ["Southeast Asia", "Thailand", "The historical kingdoms of Siam and their political, commercial and cultural relationships."],
        indochina: ["Southeast Asia", "Indochina", "Explore the distinct histories of Cambodia, Laos and Vietnam."],
        indonesia: ["Southeast Asia", "Indonesia", "Historical kingdoms, maritime exchange and the development of the Indonesian republic."],
        philippines: ["Southeast Asia", "Philippines", "An archipelago of maritime communities shaped by regional trade and successive colonial administrations."],
        sumatra: ["Southeast Asia", "Sumatra", "Maritime kingdoms, regional trade and the communities of Indonesia's western island."]
    };
    document.querySelectorAll('[data-place-map]').forEach(function (map) {
        var controls = map.querySelectorAll('[data-region]');
        var overview = map.querySelector('.bh-regional-overview');
        var mobile = window.matchMedia('(max-width: 800px)');
        function select(region) {
            var place = places[region];
            if (!place) return;
            controls.forEach(function (control) {
                var isIndonesianRegion = overview && overview.contains(control) && ['kalimantan', 'sumatra'].indexOf(control.dataset.region) !== -1;
                control.classList.toggle('is-selected', control.dataset.region === region || (region === 'indonesia' && isIndonesianRegion));
            });
            map.querySelector('[data-place-kicker]').textContent = place[0];
            map.querySelector('[data-place-title]').textContent = place[1];
            map.querySelector('[data-place-copy]').textContent = place[2];
            var link = map.querySelector('[data-place-link]');
            link.href = map.querySelector('[data-region="' + region + '"]').getAttribute('href');
            link.textContent = 'Explore ' + place[1] + ' ↗';
        }
        controls.forEach(function (control) {
            control.addEventListener('mouseenter', function () {
                if (!mobile.matches) select(control.dataset.region);
            });
            control.addEventListener('focus', function () { select(control.dataset.region); });
        });
        function setOverviewMode() {
            if (!overview) return;
            overview.setAttribute('aria-hidden', mobile.matches ? 'true' : 'false');
            overview.querySelectorAll('a').forEach(function (link) {
                link.setAttribute('tabindex', mobile.matches ? '-1' : '0');
            });
        }
        if (mobile.addEventListener) mobile.addEventListener('change', setOverviewMode);
        else mobile.addListener(setOverviewMode);
        setOverviewMode();
        select('sabah');
    });
})();
